import { render } from "./IndustryConsumerFields.vue?vue&type=template&id=f57fe36e"
import script from "./IndustryConsumerFields.vue?vue&type=script&lang=js"
export * from "./IndustryConsumerFields.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__